import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FontSizes from '../../../constants/FontSizes';
import { MainColors } from '../../../constants/Colors';
import Pagination from '../components/Pagination';
import Svg, { Rect } from 'react-native-svg';
import useFetch from '../../../utils/useFetch'

const VotesList = (props) => {
    const { get } = useFetch()
    const votesPerPage = 5
    const [currentPage, setCurrentPage] = useState(1);
    const [currentVotes, setCurrentVotes] = useState([])
    const [numberOfVotes, setNumberOfVotes] = useState(0)
    const [numberOfPages, setNumberOfPages] = useState(0)

    useEffect(() => {
        const updatePage = async () => {
            const result = await get(`/api/ballots/votes/${props.ballotItemId}?page=${currentPage}&count=${votesPerPage}`)
            setCurrentVotes(result.votes)
            setNumberOfVotes(result.numberOfVotes)
            setNumberOfPages(result.numberOfPages)
        }
        updatePage()
    }, [currentPage])

    if (!currentVotes)
        return false

    const votesList = currentVotes.map(voter => (
        <View style={styles.voteContainer}>
            <Text style={styles.voterInfo}>{voter.alias} - </Text>
            <View style={styles.colorSquareContainer}>
                <Svg width="12" height="12" viewBox="0 0 12 12">
                    <Rect x="0" y="0" width="12" height="12"
                        fill={props.choices.find(choice => choice.choiceId === voter.choice).choiceColor} />
                </Svg>
            </View>
            <Text style={styles.voterInfo}>{props.choices.find(choice => choice.choiceId === voter.choice).choiceTitle}</Text>
        </View>
    ))

    return (
        <View style={styles.container}>
            <View>
                <Text style={styles.label}>Votes</Text>
                {votesList}
            </View>
            {numberOfVotes > votesPerPage ? (
                <View>
                    <Pagination
                        itemsPerPage={votesPerPage}
                        totalItems={numberOfVotes}
                        paginate={(pageNumber) => setCurrentPage(pageNumber)}
                        currentPage={currentPage}
                    />
                </View>
            ) : (null)}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        height: 255,
        justifyContent: 'space-between',
    },
    label: {
        fontSize: FontSizes.medium,
        fontWeight: '500',
        color: MainColors.mediumGray,
        marginVertical: 10
    },
    voteContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomColor: MainColors.faintGray,
        borderBottomWidth: 1,
        paddingBottom: 5,
        marginBottom: 10,
    },
    voterInfo: {
        fontSize: FontSizes.medium,
        fontWeight: '500',
        color: MainColors.darkGray
    },
    colorSquareContainer: {
        marginRight: 5
    }
});

export default VotesList;